module.exports = __webpack_public_path__ + "assets/images/img/image1.1e6cc09e25747b730a23933b5b787e5a.png";